<template>
  <div>
    <v-container fluid class="lighten-12 content">
      <v-row>
        <v-col cols="12" class="d-flex justify-end">
          <permission-control permissionName="Income Category Create">
            <v-btn depressed small height="32" class="btn_blue" @click.stop="openCreate">
              <v-icon class="icon_small ma-2">mdi-plus</v-icon>
              Add
            </v-btn>
          </permission-control>
        </v-col>
      </v-row>
      <v-card class="lighten-12 card-content mb-2">
        <v-row class="ma-0">
          <TableFilters :filters="['status', 'search']" v-model="filter" :columns="columns" />
        </v-row>
      </v-card>
      <v-card class="lighten-12 card-content mt-0 pa-3">
        <IncomeCategoryCreate
          :visible="createVisible"
          @close="createVisible = false"
          @afterSave="refreshData"
        />
        <v-data-table
          :headers="headers"
          :items="rows"
          :items-per-page="paginationOptions.perPage"
          item-key="id"
          hide-default-footer
        >
          <template v-slot:item.status="{ item }">
            <v-chip x-small label text-color="white" :color="item.is_active ? 'green' : 'grey'">
              {{ item.is_active ? "Active" : "Archived" }}
            </v-chip>
          </template>
          <template v-slot:item.action="{ item }">
            <list-menu
              feature="incomeCategory"
              :item="item"
              editPermission="Income Category Edit"
              softDeletePermission="Income Category Soft Delete"
              :isEditModal="true"
              @refreshList="refreshData"
              @onEditClicked="openEdit(item)"
            />
          </template>
          <template v-slot:footer>
            <pagination
              url="income-categories"
              @paginationOptions="setPaginationOptions"
              @response="receiveData"
              :filter="filter"
              ref="pagination"
            />
          </template>
        </v-data-table>
        <IncomeCategoryEdit
          :visible="editVisible"
          :category="category"
          @afterSave="refreshData"
          @close="editVisible = false"
        />
      </v-card>
    </v-container>
  </div>
</template>
<script>
import TableFilters from "@/components/base/TableFilters";
import pagination from "@/modules/shared/components/pagination";
import IncomeCategoryCreate from "./IncomeCategoryCreate";
import IncomeCategoryEdit from "./IncomeCategoryEdit";
import { IncomeCategory } from "@/models/IncomeCategory";

export default {
  components: { TableFilters, pagination, IncomeCategoryCreate, IncomeCategoryEdit },
  data: () => ({
    paginationOptions: {},
    createVisible: false,
    editVisible: false,
    category: new IncomeCategory(),
    rows: [],
    columns: [
      { text: "Name", value: "name", show: true },
      { text: "Code", value: "code", show: true },
      { text: "Description", value: "description", show: true },
      { text: "Status", value: "status", show: true },
      { text: "Actions", value: "action", show: true, align: "center" },
    ],
    filter: { search: "", status: "" },
  }),
  computed: {
    headers() {
      return this.columns.filter((item) => item.show);
    },
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    receiveData(data) {
      this.rows = data || [];
    },
    refreshData() {
      if (this.$refs.pagination) this.$refs.pagination.refreshData();
    },
    openCreate() {
      this.createVisible = true;
    },
    openEdit(item) {
      this.$store.dispatch("sitesetting/GetIncomeCategory", item.id).then((res) => {
        this.category = res.data || item;
        this.editVisible = true;
      });
    },
  },
};
</script>
